import {
  Button,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import VpnKeyOutlinedIcon from "@material-ui/icons/VpnKeyOutlined";
import React, { useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useUser } from "../../contexts/UserContextProvider";
import { useTranslation } from "react-i18next";


const useStyles = makeStyles({
  menu: {
    color: "white",
    textTransform: "capitalize",
  },
  avatar: {
    marginRight: "5%",
  },
});

export default function MenuAv() {
    const { t } = useTranslation(["components"]);
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const history = useHistory();

  const [user, setUser] = useUser();

  const anchorEl = useRef();

  const handleClick = (event) => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button
        className={classes.menu}
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        ref={anchorEl}
      >
        {user?.profile?.name} {user?.profile?.lastName}
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl?.current}
        keepMounted
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            history.push("/profile");
          }}
        >
          <ListItemIcon>
            <VpnKeyOutlinedIcon />
          </ListItemIcon>
          <Typography variant="inherit">{t("components:menu_av.change_password")}</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setUser(null);
          }}
        >
          <ListItemIcon>
            <ExitToAppIcon />
          </ListItemIcon>
          <Typography variant="inherit">{t("components:menu_av.logout")}</Typography>
        </MenuItem>
      </Menu>
    </div>
  );
}
